import { APP_NAME_SHORT } from "./constants"

/**
 * Enumerazione che rappresenta le diverse app supportate. 
 * Ogni app è associata a un numero intero univoco.
 */
export enum AppEnum {
    GOT = 0,
    WICIR = 1,
    VVF = 2
}

/**
 * Determina l'app attualmente in uso e restituisce il corrispondente valore dell'enumerazione AppEnum.
 * @returns L'app corrente come valore di AppEnum.
 * @throws Error se il nome dell'app è sconosciuto.
 */
export const getCurrentApp = (): AppEnum => {
    const currentApp = APP_NAME_SHORT.toLowerCase();
    switch (currentApp) {
        case "got":
            return AppEnum.GOT;
        case "wicir":
            return AppEnum.WICIR;
        case "vvf":
        case "vvf-connect":
            return AppEnum.VVF;
        default:
            throw new Error("Unknown app");
    }
}

//#region UTILS PER LE SINGOLE APP
export const isGOT = (): boolean => getCurrentApp() === AppEnum.GOT;
export const isWICIR = (): boolean => getCurrentApp() === AppEnum.WICIR;
export const isVVF = (): boolean => getCurrentApp() === AppEnum.VVF;
//#endregion
